module.exports = __webpack_public_path__ + "static/media/logo.cd8e5639.svg";